import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ActionsWrapper = styled.div`
  display: flex;
  padding: 0 32px;
  min-height: 60px;
  align-items: center;
  background-color: ${colors.white};
`;

export const RadioWrapper = styled.div`
  padding: 10px 0px;
  padding-left: 10px;

  &:not(:first-child) {
    padding-left: 32px;
  }

  span + span {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: ${colors.black};
  }
`;

export const RightSection = styled.div`
  margin-left: auto;
`;
